import { render, staticRenderFns } from "./purchase-quote.vue?vue&type=template&id=31d80592&"
import script from "./purchase-quote.vue?vue&type=script&lang=ts&"
export * from "./purchase-quote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports